import { Locale } from "@redotech/crdb-enums/common/locale";

export const TRANSLATABLE_LANGUAGES = Object.values(Locale).filter(
  (language) => language !== Locale.En,
);
